import React from 'react';

function NorthDakota({handleClick, className}) {
  return (
    <path onClick={handleClick} className={className} id="ND" d="M471 126.4l-.4-6.2-1.8-7.3-1.8-13.61-.5-9.7-1.9-3.18-1.6-5.32V70.68l.6-3.85-1.8-5.54-28.6-.59-18.6-.6-26.5-1.3-25.2-2.16-.9 14.42-4.7 50.94 56.8 3.9 56.9 1.7z"><title>North Dakota</title></path>
  );
}

export default NorthDakota;
